<template>

  <div class="carousel-wrapper">
    <div class="carousel-track">
      <div class="carousel-inner" ref="carouselInner">
        <img
          v-for="(logo, index) in duplicatedLogos"
          :key="logo + index"
          :src="logo"
          alt="Logo"
          class="carousel-logo"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logos: [
        "/img/logos/nvidia.png",
        "/img/logos/vivex.png",
        "/img/logos/garena.png",
        "/img/logos/tal.png",
        "/img/logos/zukun.png",
        "/img/logos/acer.png",
        "/img/logos/alpha.png",
        "/img/logos/axis.png",
        "/img/logos/epic.png",
        "/img/logos/fareast.png",
        "/img/logos/gamania.png",
        "/img/logos/hinet.png",
        "/img/logos/kbs.png",
        "/img/logos/lenovo.png",
        "/img/logos/megagrants.png",
        "/img/logos/momo.png",
        "/img/logos/msi.png",
        "/img/logos/netease.png",
        "/img/logos/sanli.png",
        "/img/logos/viverse.png"
      ],
    };
  },
  computed: {
    duplicatedLogos() {
      // Duplicate the logos array to ensure smooth looping
      return [...this.logos, ...this.logos];
    }
  },
  mounted() {
    this.$nextTick(() => {
      const carouselInner = this.$refs.carouselInner;
      if (carouselInner) {
        // Wait for all images to load
        const images = carouselInner.querySelectorAll('img');
        let loaded = 0;
        images.forEach(img => {
          img.onload = img.onerror = () => {
            loaded++;
            if (loaded === images.length) {
              this.setCarouselWidth();
            }
          };
        });
      }
    });
  },
  methods: {
    setCarouselWidth() {
      const carouselInner = this.$refs.carouselInner;
      if (carouselInner) {
        const logoCount = this.logos.length;
        const logos = Array.from(carouselInner.children).slice(0, logoCount);
        if (logos.length > 0) {
          // Calculate total width including margins
          let totalWidth = 0;
          logos.forEach(logo => {
            const style = window.getComputedStyle(logo);
            const marginLeft = parseFloat(style.marginLeft);
            const marginRight = parseFloat(style.marginRight);
            totalWidth += logo.offsetWidth + marginLeft + marginRight;
          });
          carouselInner.style.setProperty('--carousel-width', `${totalWidth}px`);
          let actualFullWidth = totalWidth * 2; // Double for smooth scrolling
          carouselInner.style.width = `${actualFullWidth}px`;
        }
      }
    }
  }
};
</script>

<style scoped>
.carousel-wrapper {
  width: 100vw;
  overflow: hidden;
  background: transparent;
  padding: 20px 0;
}

.carousel-track {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.carousel-inner {
  display: flex;
  align-items: center;
  animation: scroll-left var(--carousel-duration, 30s) linear infinite;
  white-space: nowrap; /* Prevent items from wrapping */
}

.carousel-logo {
  width: 180px;
  height: 80px;
  object-fit: contain;
  margin: 0 32px;
  background: transparent;
  flex-shrink: 0; /* Prevent logo compression */
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-1 * var(--carousel-width)));
  }
}
</style>
